import { render, staticRenderFns } from "./ModusButtons.vue?vue&type=template&id=7af7052b&scoped=true&"
import script from "./ModusButtons.vue?vue&type=script&lang=js&"
export * from "./ModusButtons.vue?vue&type=script&lang=js&"
import style0 from "./ModusButtons.vue?vue&type=style&index=0&id=7af7052b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af7052b",
  null
  
)

export default component.exports